import Agreement from "./Agreement";
import Address from "./Address";
import Enrolled from "./Enrolled";
import GeneralQuestions from "./GeneralQuestions";
import MedicareInfo from "./MedicareInfo";
import Paying from "./Paying";
import PersonalInfo from "./PersonalInfo";
import Review from "./Review";
import SepEnrollments from "./SepEnrollments";

export default {
  Agreement,
  Address,
  Enrolled,
  GeneralQuestions,
  MedicareInfo,
  Paying,
  PersonalInfo,
  Review,
  SepEnrollments,
};
